export const Field = ({ label, children, hint, required }) => (
  <div>
    <label className="field-label">
      {label} {required && <span className="text-accentx">*</span>}
    </label>
    {children}
    {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
  </div>
);

export const TextField = ({ label, hint, required, testId, ...props }) => (
  <Field label={label} hint={hint} required={required}>
    <input className="field-input" data-testid={testId} {...props} />
  </Field>
);

export const TextAreaField = ({ label, hint, testId, ...props }) => (
  <Field label={label} hint={hint}>
    <textarea className="field-input min-h-[96px]" data-testid={testId} {...props} />
  </Field>
);

export const SelectField = ({ label, options, hint, required, testId, ...props }) => (
  <Field label={label} hint={hint} required={required}>
    <select className="field-input" data-testid={testId} {...props}>
      {options.map((o) => {
        const value = typeof o === "object" ? o.value : o;
        const text = typeof o === "object" ? o.label : o;
        return (
          <option key={String(value)} value={value}>
            {text}
          </option>
        );
      })}
    </select>
  </Field>
);

export const ChipGroup = ({ label, options, value = [], onChange, hint, testIdPrefix }) => (
  <Field label={label} hint={hint}>
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const active = value.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            data-testid={`${testIdPrefix}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            onClick={() => onChange(active ? value.filter((v) => v !== opt) : [...value, opt])}
            className={`rounded-full border px-3.5 py-1.5 text-sm transition-colors ${
              active
                ? "border-brand bg-brand text-white"
                : "border-slate-200 bg-white text-slate-600 hover:border-brand/40"
            }`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  </Field>
);
